import { render, staticRenderFns } from "./ImageVideoLink.vue?vue&type=template&id=4bae5be4&scoped=true&"
import script from "./ImageVideoLink.vue?vue&type=script&lang=js&"
export * from "./ImageVideoLink.vue?vue&type=script&lang=js&"
import style0 from "./ImageVideoLink.vue?vue&type=style&index=0&id=4bae5be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae5be4",
  null
  
)

export default component.exports